import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from '../styles/main.module.scss';

import GlobalContext from '../_contexts/GlobalContext';


export interface ImainComponentProps {
    
}

const MainComponent: React.FunctionComponent<ImainComponentProps> = (props: ImainComponentProps) => {
    const [init, setinit] = useState<boolean>(true);

    const { DevEnabled, DebugEnabled, Strings } = useContext(GlobalContext);

    useEffect(() => {
        
    }, []);


    return (
        init === true ? <div>Loading</div> : 
            <div>

            </div>
    );
}

export default MainComponent;